import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

jQuery(window).on('elementor/frontend/init', (e) => {
  elementorFrontend.hooks.addAction(
    'frontend/element_ready/onereach-slider-tabs.default',
    ($element) => {
      const $tabs = $element.find('.onereach-slider-tabs__tab');

      const swiper = new Swiper('.onereach-slider-tabs__swiper', {
        modules: [Autoplay, EffectFade],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        speed: 600,
        autoplay: {
          delay: 8000,
          disableOnInteraction: true,
        },
        allowTouchMove: true,
        on: {
          slideChange() {
            updateTabs(this.realIndex);
          },
        },
      });

      function updateTabs(index) {
        $tabs.removeClass('is-active').eq(index).addClass('is-active');
      }

      $tabs.on('click', function () {
        swiper.slideToLoop(jQuery(this).index());
      });
    }
  )
})
